<template>
  <div class="flex flex-col h-full content-start space-y-5">
    <div class="grid gap-2">
      <div class="flex space-x-1 items-center">
        <v-tooltip location="top">
          <template v-slot:activator="{ props }">
            <Icon v-bind="props" icon="ant-design:info-circle" class="text-xl cursor-pointer" />
          </template>
          <div class="w-40 whitespace-normal text-center">
            Select the type of sentence you want to write.
          </div>
        </v-tooltip>
        <span class="font-semibold text-sm 2xl:text-base">Select the sentence purpose</span>
      </div>

      <TlSelect
        placeholder="Select a template category"
        v-model="selectedCategory"
        :items="sentenceTemplateFeedbackData"
      />
    </div>

    <div v-if="selectedCategory" class="flex flex-col space-y-2 flex-1 w-full">
      <div class="flex space-x-1 items-center">
        <v-tooltip location="top">
          <template v-slot:activator="{ props }">
            <Icon v-bind="props" icon="ant-design:info-circle" class="text-xl cursor-pointer" />
          </template>
          <div class="w-40 whitespace-normal text-center">
            Position your cursor where you want the sentence to be inserted. Then, select and insert
            any template sentence. Modify the template to fit your text.
          </div>
        </v-tooltip>
        <span class="font-semibold text-sm 2xl:text-base"
          >Select a sentence template to insert</span
        >
      </div>
      <div class="overflow-y-auto overflow-x-hidden h-screen">
        <div class="w-full flex-1 bg-white rounded-md shadow-lg">
          <div
            v-for="(option, index) in sentenceTemplateFeedbackData[selectedCategory - 1]?.payload"
            :key="index"
            @click="insertSentence(option)"
            class="w-full hover:!bg-gray-200 py-3 px-4 break-words cursor-pointer duration-200"
          >
            <span class="">{{ option }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import TlSelect from '@/components/global/TlSelect.vue';
import { Icon } from '@iconify/vue';

import { Vue, Options } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { usePayloadStore } from '@/stores/payload';

@Options({
  components: {
    Icon,
    TlSelect
  }
})
export default class SentenceTemplates extends Vue {
  @Prop()
  public sentenceTemplateFeedbackData: any;
  private payloadStore = usePayloadStore();
  public loadingResponse = this.payloadStore.payload.loadingResponse;

  @Watch('payloadStore.payload.loadingResponse')
  public onLoadingResponse() {
    this.loadingResponse = this.payloadStore.payload.loadingResponse;
  }

  public selectedCategory: any = null;
  public selectedItem: string | null = null;
  @Watch('selectedCategory')
  public onSelectedCategory() {
  }

  public onSelectedItemChange(val: any) {
    if (val === this.selectedItem) this.selectedItem = null;
    else this.selectedItem = val;
  }

  public insertSentence(sentence: string) {
    this.$emit('insertSentence', sentence);
  }
}
</script>
